import {
  type ElementWithProps,
  createComponent
} from '@carvana/merch-components';
import cx from 'classnames';

type DefaultLayoutProp = {
  defaultLayout: boolean;
};

export const CardContainer = createComponent<
  ElementWithProps & { isDefault?: boolean }
>('div', ({ isDefault = false }) => ({
  className: cx(
    'grid grid-rows-[1fr_40px] rounded-md border border-solid border-grey-2 p-24 -:bg-white m:h-[216px] m:max-h-[216px] l:h-[211px] l:max-h-[211px]',
    { 'bg-gradient-to-b from-white to-cyan-100': isDefault }
  )
}));

export const Heading = createComponent('h3', {
  className: 'text-blue-6 tl-header-m'
});

export const HeadingContainer = createComponent<
  ElementWithProps<DefaultLayoutProp>
>('div', ({ defaultLayout }) => ({
  className: cx('flex justify-between', { 'm:col-span-2': !defaultLayout })
}));

export const Paragraph = createComponent('p', {
  className: 'text-blue-6 tl-body-m'
});

export const TradeGridWrapper = createComponent<
  ElementWithProps<DefaultLayoutProp>
>('div', ({ defaultLayout }) => ({
  className: cx(
    'grid grid-rows-[24px_137px_1fr] gap-x-24 m:grid-cols-[1fr_122px] m:gap-y-8',
    defaultLayout
      ? 'gap-y-8 m:grid-rows-[48px_48px]'
      : 'gap-y-16 m:grid-rows-[24px_1fr]'
  )
}));

export const FinanceGridWrapper = createComponent<
  ElementWithProps<DefaultLayoutProp>
>('div', ({ defaultLayout }) => ({
  className: cx(
    'grid gap-x-24 m:gap-y-8',
    defaultLayout
      ? 'grid-rows-[24px_137px_1fr] gap-y-8 m:grid-cols-[1fr_122px] m:grid-rows-[24px_72px]'
      : 'grid-rows-[24px_1fr] gap-y-16'
  )
}));
